// ====================================================================================
// readMoreMarker.module
// ====================================================================================
import $ from "jquery";

export const init = () => {

    // read-more Klapperfunktion mit ###weiterlesen### marker
    let $readMore = $('.read-more-marker');
    if ($readMore.length) {
      $readMore.each(function () {
        let $readMoreMarker = $(this);
        let $readMoreText = $readMoreMarker.nextAll();
        $readMoreMarker.html('<button class="btn btn--read btn--read-more p-0" type="button">\n' +
          '            <span>... weiterlesen</span>\n' +
          '    </button>');
        $readMoreText.hide();
        $readMoreMarker.parent().append('<div class="read-less-marker">\n' +
          '    <button class="btn btn--read btn--read-less p-0" type="button">\n' +
          '            <span>weniger lesen</span>\n' +
          '    </button>\n' +
          '</div>');
        $readMoreMarker.parent().find('.read-less-marker').hide();
        //$('.read-more').parent().nextAll().css( "background-color", "red" );
        $readMoreMarker.click(function () {
          $readMoreText.slideDown();
          $(this).hide();
          $(this).parent().parent().find('.read-less-marker').show();
        })
        $readMoreMarker.parent().parent().find('.read-less-marker').click(function () {
          $readMoreText.slideUp();
          $(this).hide();
          $(this).parent().parent().find('.read-more-marker').show();
        })
      });
    }

};
